import React from 'react';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { PresenceUserRead } from '@ragu-components/ord-types';

const PresenceList = React.lazy(async () => import('./PresenceList'));

export const presenceResource: OrdResourceProps = {
  key: `presence/users`,
  name: `presence/users`,
  list: <PresenceList />,
  hasShow: true,
  options: {},
  recordRepresentation: (record: PresenceUserRead): string => `${record.firstname} ${record.lastname}`,
};
